/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'copy': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M853.333 853.333V256A85.333 85.333 0 00768 170.667H170.667A170.667 170.667 0 01341.333 0h512A170.667 170.667 0 011024 170.667v512a170.667 170.667 0 01-170.667 170.666z"/><path pid="1" d="M312.917 568.917H241.75a71.083 71.083 0 000 142.166h71.168v71.168a71.083 71.083 0 10142.166 0v-71.168h71.168a71.083 71.083 0 000-142.166h-71.168V497.75a71.083 71.083 0 00-142.166 0v71.168zM59.136 256.768V256h649.728C741.205 256 768 282.71 768 314.965v650.07a59.477 59.477 0 01-59.136 58.88H59.136A59.477 59.477 0 010 965.12V315.733c0-32.256 26.795-59.05 59.136-59.05z"/>'
  }
})
